import CustomTable from "components/ui/CustomTable/CustomTable";
import { PurchaseReportRow } from "constants/types/report";
import { MRT_ColumnDef } from "mantine-react-table";
import { FC, useMemo } from "react";
import { formatCurrency } from "utils/helpers/format";

interface PurchaseReportTableProps {
  data: PurchaseReportRow[];
}

const PurchaseReportTable: FC<PurchaseReportTableProps> = ({ data }) => {
  // Cột dựng đúng mẫu Excel khách gửi: mỗi mặt hàng trên đơn là một dòng, nên
  // ô "Ngày-Số" lặp lại với các đơn có nhiều mặt hàng.
  const columns = useMemo<MRT_ColumnDef<PurchaseReportRow>[]>(
    () => [
      {
        id: "stt",
        header: "STT",
        size: 50,
        grow: false,
        Cell: ({ row }) => row.index + 1,
        mantineTableHeadCellProps: { align: "center" },
        mantineTableBodyCellProps: { align: "center" },
      },
      {
        accessorKey: "dateCode",
        header: "Ngày-Số",
        size: 140,
        grow: false,
      },
      {
        accessorKey: "partnerName",
        header: "Tên khách hàng/nhà cung cấp",
        minSize: 220,
        grow: true,
      },
      {
        accessorKey: "productDisplayName",
        header: "Tên mặt hàng (Thông số)",
        minSize: 280,
        grow: true,
      },
      {
        accessorKey: "quantity",
        header: "Số lượng",
        size: 100,
        grow: false,
        mantineTableHeadCellProps: { align: "center" },
        mantineTableBodyCellProps: { align: "right" },
      },
      {
        accessorKey: "unitPrice",
        header: "Đơn giá",
        size: 140,
        grow: false,
        mantineTableHeadCellProps: { align: "center" },
        mantineTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => formatCurrency(cell.getValue<number>()),
      },
      {
        accessorKey: "totalAmount",
        header: "Tổng cộng",
        size: 150,
        grow: false,
        mantineTableHeadCellProps: { align: "center" },
        mantineTableBodyCellProps: { align: "right" },
        Cell: ({ cell }) => formatCurrency(cell.getValue<number>()),
      },
    ],
    [],
  );

  return <CustomTable columns={columns} data={data} />;
};

export default PurchaseReportTable;
